import { render, staticRenderFns } from "./InquiryAndAttendance.vue?vue&type=template&id=2815e270&scoped=true"
import script from "./InquiryAndAttendance.vue?vue&type=script&lang=js"
export * from "./InquiryAndAttendance.vue?vue&type=script&lang=js"
import style0 from "./InquiryAndAttendance.vue?vue&type=style&index=0&id=2815e270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815e270",
  null
  
)

export default component.exports